/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { MultiSelectDropDown } from '@insticator/insticator-ui'; // iui-material



/* ========== ~~~~~~~~~~ EMBED : CONTROLBAR : CONTENT TYPE SORT ~~~~~~~~~~ ========== */
const ContentTypeSort = (props) => {
    return (
        <MultiSelectDropDown
    		name={'Content Type'}
    		title={'All Types'}
    		button={!!props.buttonAction}
            buttonAction={props.buttonAction}
            icon={`file`}
            onSelect={props.handleSelect}
            items={props.allTypes}
            selectedItems={props.types}
        />
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ContentTypeSort;
